import gql from 'graphql-tag';

const name = 'promotion';
const fragment = gql`
  fragment ${name} on Promotion {
    id
    ownerId
    name
    categories
    code
    image {
      url
      baseUrl
      id
    }
    metadata {
      displayName
      description
      discount
      code
      fullTerms
      shortTerms
      url
      exclusive
      contactPreferenceRequired
      templates {
        contactPreferenceForm {
          template
        }
      }
      redemption {
        barcodeImage {
          url
        }
        description
      }
    }
    placements
    redemption {
      code {
        format
        type
        value
      }
      methods {
        description
        type
        value
      }
    }
  }
`;

export default {
  name,
  fragment,
};
